import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { GetBO } from '../../pages.modal';
import { DeletepermissionBO, saveTimesheetBO, recalculateBo } from '../timesheet.modal';
import { BulkT2025UpdateBO } from '../../evvtimesheet/evvtimesheet.model';


@Injectable({
  providedIn: 'root'
})
export class TimesheetListService {

  constructor(private http: HttpClient, public errorService: ErrorService,
  ) { }
  GetClientDropDown(): Observable<any> {
    let url = "api/Client/GetClientDropDown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  GetAllEmployeesDropdown(): Observable<any> {
      let url = "api/Employee/GetAllEmployeesDropdown?";
      return this.http.get<any>(url, { observe: 'response' }).pipe(
        map(data => data.body),
        catchError(this.errorService.handleError)
      )
}
GetAllClientDropDown(): Observable<any> {
  let url = "api/Client/GetAllClientDropDown?";
  return this.http.get<any>(url, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}

UpdateTimesheet(UpdateTimesheet: saveTimesheetBO): Observable<any> {
  let url = "api/Timesheets/UpdateTimesheet";
  return this.http.post(url, UpdateTimesheet, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}

DeleteTimeSheet(Delete: DeletepermissionBO): Observable<any> {
  let url = "api/Timesheets/DeleteTimeSheet?"
  return this.http.post<any>(url , Delete, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  );
}

UpdateRateTimesheet(params:recalculateBo): Observable<any> {
  let url = "api/Timesheets/UpTimesheet";
  return this.http.post<any>(url,params,{ observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}


exportcsv(getBO: GetBO): Observable<any> {
  let url = "api/Timesheets/getTimesheetExportAsync";
  return this.http.post(url, getBO, { observe: 'response' }).pipe(

    map(data => data.body),
    catchError(this.errorService.handleError))


}

updateMulitpleTimesheets(getBO: BulkT2025UpdateBO): Observable<any> {
  let url = "api/Timesheets/BulkTimesheetUpdate";
  return this.http.post(url, getBO, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError))


}



}
